// gameEventTypes
export const gameEventTypes = Object.freeze({
  'loading': -1,
  'created': 0,
  'play': 1,
  'pause': 2,
  'rollover': 3,
  'next': 4,
  'previous': 5,
  'topup': 6,
  'delete': 7,
  'knockout': 8,
  'finished': 9,
  'heartbeat': 10
})

export const signInProvider = Object.freeze({
  'unknown': -1,
  'email': 0,
  'google': 1,
  'facebook': 2,
  'twitter': 3,
  'playGames': 4,
  'phone': 5,
  'github': 6,
  'anonymous': 7
})

export const isInUse = Object.freeze({
  'unchecked': -1,
  'no': 0,
  'yes': 1
})

export const gameProgress = Object.freeze({
  'unset': -1,
  'created': 0,
  'in_progress': 1,
  'finished': 2
})

export const seasonObjectTypes = Object.freeze({
  'player': 0,
  'game': 1,
  'schedule': 2,
  'level': 3,
  'event': 4,
  'timerEvent': 5
})

export const blindLevelTypes = Object.freeze({
  'blind': 0,
  'break': 1
})

export const rebuysAllowed = Object.freeze({
  'untilFirstBreakEnd': 0,
  'untilSecondBreakEnd': 1,
  'always': 2,
  'never': 3
})

export const topupsAllowed = Object.freeze({
  'duringFirstBreak': 0,
  'duringFirstAndSecondBreak': 1,
  'untilFirstBreakEnd': 2,
  'untilSecondBreakEnd': 3,
  'always': 4,
  'never': 5
})

export const sounds = Object.freeze({
  'fiveSecondWarningBeep': '/static/alarm_beep_1.mp3',
  'threeSecondWarningBeep': '/static/alarm_beep_1.mp3',
  'oneSecondWarningBeep': '/static/alarm_beep_1.mp3'
})

export const userStatus = Object.freeze({
  'offline': 0,
  'online': 1
})

/**
* Returns a random integer between min (inclusive) and max (inclusive)
*/
export const randomInteger = function getRandomInt (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * Returns a string representation of the number, with commas.
 */
export const numberWithCommas = function (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Plays the sound file passed to it
 */
export const playSound = function (sound) {
  return new Promise(function (resolve, reject) { // return a promise
    var audio = new Audio() // create audio wo/ src
    audio.preload = 'auto' // intend to play through
    audio.autoplay = true // autoplay when loaded
    audio.onerror = reject // on error, reject
    audio.onended = resolve // when done, resolve

    audio.src = sound
  })
}

export function whatIsIt (object) {
  let stringConstructor = 'test'.constructor
  let arrayConstructor = [].constructor
  let objectConstructor = ({}).constructor

  if (object === null) {
    return 'null'
  }
  if (object === undefined) {
    return 'undefined'
  }
  if (object.constructor === stringConstructor) {
    return 'String'
  }
  if (object.constructor === arrayConstructor) {
    return 'Array'
  }
  if (object.constructor === objectConstructor) {
    return 'Object'
  }
  return 'unknown'
}

export function clearArray (array) {
  array.splice(0, array.length)
}

export function calculateCardPosition (cardInfo, windowWidth, scale) {
  let columns = []
  let cards = cardInfo.cards
  let sortBy = []
  let columnProperty = 'bigScreenColumn'
  let rowProperty = 'bigScreenRow'

  if (cardInfo.screenTransitionWidth > windowWidth) {
    columnProperty = 'smallScreenColumn'
    rowProperty = 'smallScreenRow'
  }

  sortBy = [{
    prop: columnProperty,
    direction: 1
  }, {
    prop: rowProperty,
    direction: 1
  }]

  cards.sort(function (a, b) {
    let i = 0
    let result = 0
    while (i < sortBy.length && result === 0) {
      result = sortBy[i].direction * (a[sortBy[i].prop] < b[sortBy[i].prop] ? -1 : (a[sortBy[i].prop] > b[sortBy[i].prop] ? 1 : 0))
      i++
    }
    return result
  })

  let maxColumnWidth = 0
  let columnStart = 0
  let currentColumn = 0
  let currentColumnHeight = 0
  let cardWidth = 0
  let newColumn = []
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i]
    let newCard = {
      id: card.id,
      top: (currentColumnHeight + (cardInfo.rowPadding * scale)),
      left: (columnStart + (cardInfo.columnPadding * scale))
    }
    cardWidth = newCard.left + (card.width * scale)
    if (cardWidth > maxColumnWidth) {
      maxColumnWidth = cardWidth
    }
    currentColumnHeight = newCard.top + (card.height * scale)
    currentColumn = card[columnProperty]
    newColumn.push(newCard)
    if (((i + 1) < cards.length && cards[i + 1][columnProperty] !== currentColumn) || (i + 1) === cards.length) {
      columns.push(newColumn)
      columnStart = maxColumnWidth
      maxColumnWidth = 0
      currentColumnHeight = 0
      newColumn = []
    }
  }

  return columns
}

export function endSearchString (beginSearchString) {
  let chars = ' 0123456789abcdefghijklmnopqrstuvwxyz'
  let lastChar = beginSearchString[beginSearchString.length - 1]
  let nextChar = ''
  let endString = beginSearchString.substring(0, beginSearchString.length - 1)
  while (lastChar === 'z' && endString.length > 0) {
    lastChar = endString[endString.length - 1]
    endString = endString.substring(0, endString.length - 1)
  }

  if (lastChar !== 'z') {
    for (let i = 0; i < chars.length; i++) {
      const char = chars[i]
      if (lastChar === char) {
        nextChar = chars[i + 1]
      }
    }
  } else {
    nextChar = '0'
  }

  endString = endString + nextChar
  return endString
}

export function caseFoldNormalize (s) {
  return s.trim().normalize('NFKC').toLowerCase().toUpperCase().toLowerCase()
}

export function userSignInProvider (currentUser) {
  return new Promise((resolve, reject) => {
    let provider = signInProvider.unknown
    currentUser.getIdTokenResult().then(idTokenResult => {
      switch (idTokenResult.signInProvider) {
        case 'google.com':
          provider = signInProvider.google
          break
        case 'password':
          provider = signInProvider.email
          break
        case 'github.com':
          provider = signInProvider.github
          break
        case 'phone':
          provider = signInProvider.phone
          break
        case 'twitter.com':
          provider = signInProvider.twitter
          break
        case 'playgames.google.com':
          provider = signInProvider.playGames
          break
        case 'facebook.com':
          provider = signInProvider.facebook
          break
        case 'firebase':
          provider = signInProvider.anonymous
          break
      }

      resolve(provider)
    }).catch(err => {
      reject(err)
    })
  })
}
